import { useEffect, useState } from "react";
import { ContiguousTimeslot, Timeslot } from "../timeslots.types";
import { findContiguousTimeslots } from "../utils/findContiguousTimeslots";

export function useContiguousTimeslots(
  selectedTimeSlots: Timeslot[],
  minValidContiguousDuration: number
) {
  const [contiguousTimeslots, setContiguousTimeslots] = useState<
    ContiguousTimeslot[]
  >([]);

  const [validHoursCount, setValidHoursCount] = useState(0);

  // Keep track of contiguous slots
  useEffect(() => {
    const foundSlots = findContiguousTimeslots(selectedTimeSlots);

    setContiguousTimeslots(foundSlots || []);
  }, [selectedTimeSlots]);

  // Keep track of the number of 2-hour slots
  useEffect(() => {
    // Calculate total number of 2-hour slots in all contiguous blocks

    let totalValidHours = 0;

    for (const slot of contiguousTimeslots) {
      // Add the number of valid contiguous slots in this contiguous block
      if (slot.duration >= minValidContiguousDuration) {
        totalValidHours += slot.duration;
      }
    }

    setValidHoursCount(totalValidHours);
  }, [contiguousTimeslots]);

  return { contiguousTimeslots, validHoursCount };
}

export default useContiguousTimeslots;
